<template>
  <div class="layout-user-modify-password"
       v-loading="modifyPassword.isCommitting"
       element-loading-text="请求提交中，请稍等...">
    <AppScrollbar style="height: 100%">
      <el-form ref="modifyPasswordForm"
               :model="modifyPassword.form"
               :rules="modifyPassword.rules"
               size="mini">
        <el-form-item prop="oldPwd">
          <PasswordField v-model="modifyPassword.form.oldPwd" placeholder="输入原密码"></PasswordField>
        </el-form-item>
        <el-form-item prop="newPwd">
          <PasswordField v-model="modifyPassword.form.newPwd" placeholder="输入新密码"></PasswordField>
        </el-form-item>
        <el-form-item prop="confirmPwd">
          <PasswordField v-model="modifyPassword.form.confirmPwd" placeholder="确认新密码"></PasswordField>
        </el-form-item>
        <el-form-item>
          <div class="button-group">
            <el-button type="primary" :disabled="modifyPassword.isCommitting" @click="submitModifyPassword">提交修改</el-button>
            <el-button type="default" @click="resetModifyPassword">重置表单</el-button>
          </div>
        </el-form-item>
      </el-form>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../elements/AppScrollbar'
import PasswordField from '../elements/PasswordField'

export default {
  name: 'UserModifyPassword',
  components: {AppScrollbar, PasswordField},
  data () {
    return {
      modifyPassword: {
        isCommitting: false,
        form: {
          oldPwd: '',
          newPwd: '',
          confirmPwd: ''
        },
        rules: {
          oldPwd: [{
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }],
          newPwd: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[0-9A-Za-z]{8,20}$/
              if (regex.test(value)) {
                callback()
              } else {
                callback(new Error('密码需包含大小写字母和数字，长度8-20位'))
              }
            },
            trigger: 'blur'
          }],
          confirmPwd: [{
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur'
          }]
        }
      }
    }
  },
  methods: {
    submitModifyPassword () {
      let modifyPasswordForm = this.$refs['modifyPasswordForm']
      modifyPasswordForm.validate((valid) => {
        if (valid) {
          if (this.modifyPassword.form.newPwd === this.modifyPassword.form.oldPwd) {
            this.$message.error({
              message: '新密码不能与旧密码相同',
              center: true
            })
            return
          }
          if (this.modifyPassword.form.confirmPwd !== this.modifyPassword.form.newPwd) {
            this.$message.error({
              message: '确认密码与新密码不一致',
              center: true
            })
            return
          }
          const oldPwd = this.$md5(this.modifyPassword.form.oldPwd)
          const newPwd = this.$md5(this.modifyPassword.form.newPwd)
          // 修改密码
          this.modifyPassword.isCommitting = true
          this.$ajax({
            url: '/workspace/manager/center/modifyPwd',
            method: 'post',
            data: this.$qs.stringify({
              oldPwd: oldPwd,
              newPwd: newPwd
            }),
            disableErrorPage: true
          }).then((response) => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message({
                    message: response.data['message'],
                    type: 'success',
                    center: true
                  })
                  this.resetModifyPassword()
                  break
                }
                default: {
                  this.$message({
                    message: response.data['message'],
                    type: 'warning',
                    center: true
                  })
                  break
                }
              }
            }
          }, () => {
            this.$message.error({
              message: '请求发送失败，请稍后重试',
              center: true
            })
          }).finally(() => {
            this.modifyPassword.isCommitting = false
          })
        }
      })
    },
    resetModifyPassword () {
      let modifyPasswordForm = this.$refs['modifyPasswordForm']
      modifyPasswordForm.resetFields()
      this.$nextTick(() => {
        modifyPasswordForm.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss">
  .layout-user-modify-password {
    height: 100%;
    background-color: #fff;
    padding: 15px;
    .el-form {
      width: 420px;
      max-width: 100%;
      margin: auto;
      padding: 30px;
      box-sizing: border-box;
      & > .el-form-item {
        margin-bottom: 25px;
        .el-form-item__label {
          color: #909399;
          font-size: 12px;
        }
        .button-group {
          text-align: center;
        }
      }
    }
  }
</style>
